﻿import {UIBase} from "../Tools/Base/UIBase";
import {UIState} from "../../enums";
import {NUtils} from "../../Utils/NUtils";
import {Core} from "../../Base/Core";
import {UISprite} from "../Tools/Base/UISprite";
import {UIButton} from "../Tools/Base/UIButton";
import {UIText} from "../Tools/Base/UIText";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UIBonusTimer} from "../UIBonusTimer";
import {gsap} from "gsap";

class CollectionButton extends UIButton {

    Awake() {
        this.back = this.addChild(new UINineSlice("button-square-orange"));
        this.icon = this.back.addChild(new UISprite("ico-collection"));
    }

    Init() {
        this.on("pointertap", () => Core.UI.collection.Show());
        this._initTapHighlight(this.back);
    }

    fitLayout(rect) {
        this.position.copyFrom(rect);

        this.back.width = rect.width;
        this.back.height = rect.height;

        this.icon.scale.set(rect.height * 0.7 / this.icon.texture.height);
        this.icon.position.set(rect.width * 0.5, rect.height * 0.5);
    }
}

class SoftButton extends UIButton {

    Awake() {
        this.back = this.addChild(new UINineSlice("bg-rounding-28px"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.5;

        this.icon = this.addChild(new UISprite("ico-gold"));
        this.balance = this.addChild(new UIText("", {
            fitTextTemplate: "000.0X",
        }));
        this.button = this.addChild(new UISprite("btn-add"));
    }

    Init() {
        this.on("pointertap", () => Core.UI.SetState(UIState.BankSoft));
    }

    updateUI() {
        this.balance.text = NUtils.FormatMoney(Core.Player.MoneySoft);
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;
        this.back.fitLayout(rect);

        rect.pad(-parentRect.height * 0.2, -parentRect.height * 0.15);

        let iconRect = rect.clone();
        iconRect.width = iconRect.height;
        this.icon.fitRect(iconRect);

        let buttonRect = iconRect.clone().pad(-rect.height * 0.2);
        buttonRect.x = rect.right - buttonRect.width;
        this.button.fitRect(buttonRect);

        let textRect = iconRect.clone();
        textRect.x = iconRect.right + rect.width * 0.05;
        textRect.width = buttonRect.left - iconRect.right - rect.width * 0.1;
        this.balance.fitLayout(textRect);
    }
}

// soft_per_second
class SoftSpeedButton extends UISprite {
    Awake() {

        super.Awake();

        this.back = this.addChild(new UINineSlice("bg-rounding-28px"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.5;

        this.icon = this.addChild(new UISprite("ico-gold"));
        this.speedValue = this.addChild(new UIText("", {
            fitTextTemplate: "000.0X",
        }));
        this.speedValue.anchor.set(0, 0);
        this.speedLabel = this.addChild(new UIText(Core.Localizator.Get("soft_per_second"), {
            fontSize: 16 * Core.app.renderer.resolution
        }));
        this.speedLabel.anchor.set(0, 0);
        this.bonusTimer = this.addChild(new UIBonusTimer());
    }

    updateUI() {
        if (!GameManager.gameController) return;
        let speed = GameManager.gameController.MoneySoftSpeed;
        this.speedValue.text = NUtils.FormatMoney(speed);

        this.bonusTimer.Update(Core.Player.Timers.incomeX4BoosterTimerId);
        if (!this.bonusTimer.Active) {
            this.bonusTimer.Update(Core.Player.Timers.incomeBoosterTimerId);
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;
        this.back.fitLayout(rect);

        rect.pad(-parentRect.height * 0.2, -parentRect.height * 0.15);

        let iconRect = rect.clone();
        iconRect.width = iconRect.height;
        this.icon.fitRect(iconRect);

        let textRect = iconRect.clone();
        textRect.x = iconRect.right + rect.width * 0.05;
        textRect.width = rect.width - textRect.left;
        textRect.height = rect.height * 0.6;
        this.speedValue.fitLayout(textRect);

        textRect.y += textRect.height;
        textRect.height = rect.height * 0.4;
        this.speedLabel.fitLayout(textRect);

        let bonusRect = new PIXI.Rectangle(
            parentRect.width - parentRect.height * 0.4,
            parentRect.height - parentRect.height * 0.4,
            parentRect.height * 0.5,
            parentRect.height * 0.5
        );
        this.bonusTimer.fitLayout(bonusRect);
    }
}

class HardButton extends UIButton {

    get diamondGlobalParams() {
        let {
            a: scale,
            tx: x,
            ty: y
        } = this.icon.transform.worldTransform;
        return {
            scale: scale * Core.app.renderer.resolution,
            x: x * Core.app.renderer.resolution,
            y: y * Core.app.renderer.resolution,
        };
    }

    Awake() {
        this.back = this.addChild(new UINineSlice("button-shop"));
        this.icon = this.addChild(new UISprite("ico-diamond"));
        this.balance = this.addChild(new UIText(""));
        this.button = this.addChild(new UISprite("btn-add"));
    }

    Init() {
        this.on("pointertap", () => Core.UI.SetState(UIState.BankHard));
    }

    updateUI() {
        this.balance.text = NUtils.FormatMoney(Core.Player.MoneyHard);
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;
        this.back.fitLayout(rect);

        rect.pad(-parentRect.height * 0.2, -parentRect.height * 0.15);

        let iconRect = rect.clone();
        iconRect.width = iconRect.height;
        this.icon.fitRect(iconRect);

        let buttonRect = iconRect.clone().pad(-rect.height * 0.2);
        buttonRect.x = rect.right - buttonRect.width;
        this.button.fitRect(buttonRect);

        let textRect = iconRect.clone();
        textRect.x = iconRect.right + rect.width * 0.05;
        textRect.width = buttonRect.left - iconRect.right - rect.width * 0.1;
        this.balance.fitLayout(textRect);
    }
}

class TapChallengeMergeProgress extends UISprite {

    get progress() {
        return this._progress;
    }

    set progress(val) {
        this._progress = Math.max(0, Math.min(1, val));
        this.progressBar.width = this.progressBack.width * this._progress;
    }

    Awake() {
        this._progress = 0;
        this._progressAnimation = null;

        this.progressBack = this.addChild(new UINineSlice("bg-bar"));
        this.progressBack.tint = 0x000000;
        this.progressBack.alpha = 0.5;

        this.progressBar = this.addChild(new UINineSlice("bg-bar"));
        this.progressBar.tint = 0x00FF00;

        this.icon = this.addChild(new UISprite("ico-diamond"));

        this.updateUI = this.updateUI.bind(this);
    }

    Init() {
        Core.Player.on("Changed", this.updateUI);
        this.updateUI();
    }

    _targetProgress;
    _animateProgress() {
        this._targetProgress = Core.Player.PlanetsSave.CurrentPlanet.mergeProgressPercentage || 0;
        if (this._progressAnimation) {
            if (this._progressAnimation.progress() === 1) {
                this._progressAnimation.kill();
                this._progressAnimation = null;
            }
            else return;
        }
        if (this._targetProgress === 0 || this._progress === this._targetProgress) {
            this.progress = this._targetProgress;
            return;
        }
        this._progressAnimation = gsap.timeline()
            .delay(1) // see VFX duration, run when particles reached the bar
            .to(this,{progress: this._targetProgress, duration: 0.5})
        ;
    }

    updateUI() {
        let active = Core.Player.Initialized && Core.Player.PlanetsSave.CurrentPlanet.mergeProgressTarget > 0;
        this.SetActive(active);
        this._animateProgress();
    }

    fitLayout(rect) {
        this.position.copyFrom(rect);

        this.progressBack.height = this.progressBar.height = rect.height * 0.3;
        this.progressBack.y = this.progressBar.y = (rect.height - this.progressBack.height) * 0.5;

        this.icon.scale.set(rect.height / this.icon.texture.height);
        this.icon.position.set(rect.width - this.icon.width * 0.5, rect.height * 0.5);

        this.progressBack.width = rect.width - this.icon.width * 0.9;
        this.updateUI();
    }
}

export class UIMoneyButtons extends UIBase {

    Awake() {
        super.Awake();
        this.softBtn = this.addChild(new SoftButton());
        this.softSpeedBtn = this.addChild(new SoftSpeedButton());
        this.hardBtn = this.addChild(new HardButton());
        this.collectionBtn = this.addChild(new CollectionButton());
        this.tapChallengeMergeProgress = this.addChild(new TapChallengeMergeProgress());

        this.hardMoneyFromBonus = null; // Transform hardMoneyFromBonus;
        this.hardMoneyObject = this.hardBtn.icon; // Position used for bonus flying effect
    }

    Init() {
        super.Init();

        this.softBtn.Init();
        this.softSpeedBtn.Init();
        this.hardBtn.Init();
        this.collectionBtn.Init();

        this.onMergeBonus = this.onMergeBonus.bind(this);
        this.onPlayerDataChanged = this.onPlayerDataChanged.bind(this);
        this.onMoneySoftSpeedUpdated = this.onMoneySoftSpeedUpdated.bind(this);

        Core.Player.on("MergeBonus", this.onMergeBonus);
        Core.Player.on("Changed", this.onPlayerDataChanged);

        this.tapChallengeMergeProgress.Init();
    }

    fitLayout(viewport) {

        let padding = viewport.width * 0.01;
        let buttonsRect = new PIXI.Rectangle(
            padding, padding, viewport.width - padding * 2, viewport.width * 0.1
        );

        let progressRect = buttonsRect.clone();
        progressRect.y += buttonsRect.height + padding;
        progressRect.height = buttonsRect.height * 0.5;

            // First position collection button on right
        let collectionRect = buttonsRect.clone();
        collectionRect.width = buttonsRect.height * 0.75;
        collectionRect.x += buttonsRect.width - collectionRect.width;
        this.collectionBtn.fitLayout(collectionRect);

        // Calculate the space left for other buttons
        buttonsRect.width -= collectionRect.width + padding;

        // Distribute buttons horizontally with equal widths and padding
        let buttonsCount = 3;
        let buttonRect = buttonsRect.clone();
        buttonRect.width = (buttonsRect.width - padding * (buttonsCount - 1)) / buttonsCount;

        this.softBtn.fitLayout(buttonRect);

        buttonRect.x += buttonRect.width + padding;
        this.softSpeedBtn.fitLayout(buttonRect);

        buttonRect.x += buttonRect.width + padding;
        this.hardBtn.fitLayout(buttonRect);

        this.tapChallengeMergeProgress.fitLayout(progressRect);
    }

    onMergeBonus() {
        if (Core.GameData.TapChallenge.isActive) {
            Core.UI.tapChallenge.Show();
        }
    }

    Show() {
        super.Show();
        this.onPlayerDataChanged();
        GameManager.gameController.on("MoneySoftSpeedUpdated", this.onMoneySoftSpeedUpdated);
        this.onMoneySoftSpeedUpdated();
    }

    Hide() {
        GameManager.gameController.off("MoneySoftSpeedUpdated", this.onMoneySoftSpeedUpdated);
        super.Hide();
    }

    onMoneySoftSpeedUpdated() {
        this.softSpeedBtn.updateUI();
    }

    onPlayerDataChanged() {
        if (!Core.Player.Initialized) return;
        this.softBtn.updateUI();
        this.softSpeedBtn.updateUI();
        this.hardBtn.updateUI();
        this.tapChallengeMergeProgress.updateUI();
    }

    Update() {
        this.tapChallengeMergeProgress.updateUI();
        this.softSpeedBtn.updateUI();
    }

}
